/**
 * errorCode de negócio do POST NotaFiscalEntrada/formacaoPrecos/aplicar que a tela trata de forma própria.
 * Espelha FormacaoPrecosNFeEntradaErrorCodeEnum do OrquestradorCompras (os demais erros voltam com errorCode 0).
 */
export enum FormacaoPrecosNFeEntradaErrorCodeEnum {
  /** A formação desta nota já foi aplicada e o pedido veio sem a confirmação: a tela pede a confirmação e reenvia. */
  AplicacaoAnteriorSemConfirmacao = 1,
}
